export default {
  segment_labels: {
    active: 'Active',
    cancelled: 'Anulate',
    completed: 'Finalizate',
  },
};
